import { Component, input, output, ChangeDetectionStrategy, ViewEncapsulation, computed } from "@angular/core";
import { CommonModule } from "@angular/common";
import { LucideAngularModule, ChevronLeft, ChevronRight } from "lucide-angular";
import { type AgentChatUserMessageOnSwitchToBranchProps } from "./ai-chat-user-message.types";
import { cn } from "../utils/utils";
import { UserMessage } from "@ag-ui/core";

@Component({
  standalone: true,
  selector: "agent-chat-user-message-branch-navigation",
  imports: [CommonModule, LucideAngularModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  template: `
    @if (showNavigation()) {
    <div [class]="computedClass()">
      <button type="button" [class]="buttonClass" [disabled]="!canGoPrev()" (click)="handlePrevious()">
        <lucide-angular [img]="ChevronLeftIcon" [size]="20"></lucide-angular>
      </button>
      <span class="achat-branch-nav__label"> {{ currentBranch() + 1 }}/{{ numberOfBranches() }} </span>
      <button type="button" [class]="buttonClass" [disabled]="!canGoNext()" (click)="handleNext()">
        <lucide-angular [img]="ChevronRightIcon" [size]="20"></lucide-angular>
      </button>
    </div>
    }
  `,
})
export class AgentChatUserMessageBranchNavigation {
  currentBranch = input<number>(0);

  numberOfBranches = input<number>(1);

  message = input<UserMessage>();

  inputClass = input<string | undefined>();

  switchToBranch = output<AgentChatUserMessageOnSwitchToBranchProps>();

  readonly ChevronLeftIcon = ChevronLeft;

  readonly ChevronRightIcon = ChevronRight;

  readonly buttonClass = "achat-msg-btn achat-msg-btn--sm";

  showNavigation = computed(() => this.numberOfBranches() > 1);

  canGoPrev = computed(() => this.currentBranch() > 0);

  canGoNext = computed(() => this.currentBranch() < this.numberOfBranches() - 1);

  computedClass = computed(() => cn("achat-branch-nav", this.inputClass()));

  handlePrevious(): void {
    if (this.canGoPrev()) {
      const newIndex = this.currentBranch() - 1;
      this.switchToBranch.emit({
        branchIndex: newIndex,
        numberOfBranches: this.numberOfBranches(),
        message: this.message()!,
      });
    }
  }

  handleNext(): void {
    if (this.canGoNext()) {
      const newIndex = this.currentBranch() + 1;
      this.switchToBranch.emit({
        branchIndex: newIndex,
        numberOfBranches: this.numberOfBranches(),
        message: this.message()!,
      });
    }
  }
}
